import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { getOrganization } from '../apis/apiList/organizationApi';
import { useMessage } from '../context/MessageContext';
import { Box, Stack, Typography, Tabs, Tab } from '@mui/material';
import ProductionTeam from '../components/organization/ProductionTeam';
import ProjectList from '../components/organization/ProjectList';
import ClipLoader from "react-spinners/ClipLoader";
import theme from '../theme/theme';
import EditIcon from '@mui/icons-material/Edit';
import NotesAndReminder from '../components/organization/NotesAndReminder';
import OrganizationMeetings from '../components/organization/OrganizationMeetings';
import { useApp } from '../context/AppContext';

const override = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgb(12 5 5 / 5%)",
    backdropFilter: "blur(5px)",
    zIndex: 999,
};


const Organization = () => {
    const [organization, setOrganization] = useState(null);
    const { showMessage } = useMessage();
    const { id } = useParams();
    const [value, setValue] = React.useState(0);
    const [loading, setLoading] = useState(true);
    const [productionTeamList, setProductionTeamList] = useState([])
    const navigate = useNavigate()
    const { userDetails } = useApp();

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    useEffect(() => {
        async function fetchOrganization() {
            if (id) {
                try {
                    const org = await getOrganization({ id: id })
                    console.log('org', org);
                    setOrganization(org.data);
                } catch (err) {
                    console.log('err', err);
                    if (err?.response) {
                        showMessage(err?.response?.data?.message, 'error');
                    } else {
                        showMessage(err?.message, 'error');
                    }
                }
            }
        }
        fetchOrganization();
    }, [])

    const handleProductionTeamList = (users)=>{
        setProductionTeamList(users)
    }

    const tabStyle = {
        fontSize: '17px',
        textTransform: 'capitalize',
        paddingY: '0px',
        paddingRight: '20px',
        color: '#333',
        maxHeight: '38px',
        minHeight: '20px'
    }

    return (
        <>
            {organization ?
                // <Box p={{xs:'20px 20px 180px 20px', md: '20px 40px 180px 100px'}}>
                <Box mt={0}>
                    <Stack direction={{xs: 'column', md: 'row'}} gap={2} marginBottom={'40px'}>
                        <Box>
                            <img src={organization?.orgLogoFileId || '/images/no-image-found.png'} style={{ maxWidth: '225px', maxHeight: '130px' }}></img>
                        </Box>
                        <Box>
                            <Stack direction={'column'} gap={2}>
                                <Stack direction={'row'} gap={3} alignItems={'center'} >
                                    <Typography variant='h2' component={'h5'}>
                                        {organization?.organizationName && organization.organizationName[0].toUpperCase() + organization.organizationName.slice(1)}
                                    </Typography>
                                    <Box sx={{ width: '30px',
                                        height: '30px',
                                        borderRadius: '50%',
                                        backgroundColor: '#e5e5e5',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer'
                                    }} onClick={() => { navigate(`/organization/edit/${organization._id}`) }}>
                                        <EditIcon sx={{ color: '#000', cursor: 'pointer', fontSize: '20px' }} />
                                    </Box>
                                </Stack>
                                <Box>
                                    <Typography component={'p'}>
                                        {organization?.street}
                                    </Typography>
                                    <Typography component={'p'}>
                                        {organization?.city}{(organization?.state || organization?.zip) && ','} &nbsp;
                                        {organization?.state} &nbsp;
                                        {organization?.zip}
                                    </Typography>
                                    <Typography component={'p'}>
                                        {organization?.phone}
                                    </Typography>
                                </Box>
                            </Stack>
                        </Box>
                    </Stack>
                    <Box>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" sx={{ minHeight: '35px' }} >
                                <Tab label="Projects" {...a11yProps(0)}
                                    sx={{
                                        ...tabStyle,
                                        borderRight: '1px solid #CCC',
                                        paddingLeft: '0px',
                                    }}
                                />
                                <Tab label="Production Team" {...a11yProps(1)}
                                    sx={{ ...tabStyle, borderRight: '1px solid #CCC',
                                        }}
                                />
                                {
                                    (userDetails.email == process.env.REACT_APP_JIM_EMAIL || userDetails.email == process.env.REACT_APP_DARCY_EMAIL) &&
                                    <Tab label="Notes & Reminders" {...a11yProps(1)}
                                        sx={{ ...tabStyle, borderRight: '1px solid #CCC', }}
                                    />
                                }
                                <Tab label="Meetings" {...a11yProps(3)} sx={{ ...tabStyle }}/>
                                {/* <Tab label="Time Log" {...a11yProps(2)} /> */}
                            </Tabs>
                        </Box>
                        <CustomTabPanel value={value} index={0}>
                            <ProjectList orgId={id} organization={organization}/>
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1}>
                            <ProductionTeam handleProductionTeamList={handleProductionTeamList} productionTeamList={productionTeamList} orgId={id} organization={organization} />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={2}>
                            <NotesAndReminder orgId={id} />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={3}>
                            <OrganizationMeetings orgId={id} />
                        </CustomTabPanel>
                        {/* <CustomTabPanel value={value} index={2}>
                            Item Three
                        </CustomTabPanel> */}
                    </Box>
                </Box >
                :
                <>
                    <Box sx={override}>
                        <ClipLoader
                            color={theme.palette.primary.main}
                            loading={loading}
                            size={150}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                    </Box>
                </>
            }
        </>
    )
}

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ paddingY: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default Organization
